<template>
  <div>
    <navleft></navleft>
    <div style="height: 50px;width: 50%;"></div>
      <div class="framemain">
        <iframe :src="iframe_right.url" frameborder="0" width="100%" height="100%" @onload="cs(this)"></iframe>
      </div>
  </div>

</template>

<script >
  import NavLeft from '../../components/company/public/NavLeft.vue';
  import NavTop from '../../components/company/public/NavTop.vue';
  export default {
    data() {
      return {
        info:this.$route.query.choice,
        iframe_right:{
          url:'/chome'
        },
      }
    },
    components: {
      navleft: NavLeft,
      navtop: NavTop,
    },
    mounted:function(){
      this.infoc();
    },
    methods:{
      infoc(){
         this.iframe_right.url='/'+this.info
      },
      change(val){
        this.$router.push({
          path:'/cindex?choice='+val
        })
        this.iframe_right.url='/'+val
      },
    }
  }
</script>

<style scoped>
  .framemain {
    width: 83.3%;
    height: calc(100vh - 50px);
    float: right;
    max-width: calc(100% - 235px);
    overflow: hidden;
    overflow-y: hidden;
  }

@media screen and (max-width: 1200px) {
.framemain {width: calc( 100% - 200px);}
}
</style>



// WEBPACK FOOTER //
// src/view/company/index.vue